import axios from 'axios';
import router from '../Router/index';

export default {
  namespaced: true,

  state: {
    loading: false
  },

  getters: {
    getLoading(state) {
      return state.loading;
    }
  },

  mutations: {
    SET_LOADING(state, value) {
      state.loading = value;
    }
  },

  actions: {
    setLoaded({ commit, state }, value) {
      commit('SET_LOADING', value);
    }
  }
};
